/**
 * Network graph — entity in centre, linked nodes radial.
 * Pure SVG, no deps. Click a node → re-screens it via onNodeClick().
 */
import React from "react";

export default function NetworkGraph({ network, onNodeClick }) {
  const center = network?.center || { label: "", flagged: false };
  const nodes = network?.nodes || [];
  const W = 520, H = 360;
  const cx = W / 2, cy = H / 2, ringR = 130;

  const points = nodes.map((n, i) => {
    const a = (Math.PI * 2 * i) / Math.max(nodes.length, 1) - Math.PI / 2;
    return { ...n, x: cx + ringR * Math.cos(a), y: cy + ringR * Math.sin(a) };
  });

  const colorFor = (flagged) => (flagged ? "#ef4444" : "#2563eb");

  return (
    <svg data-testid="network-graph" width="100%" height={H} viewBox={`0 0 ${W} ${H}`}>
      {/* Edges */}
      {points.map((p, i) => (
        <line key={`e-${i}`} x1={cx} y1={cy} x2={p.x} y2={p.y}
              stroke={p.flagged ? "#ef444466" : "#1e2530"} strokeWidth={1.5} />
      ))}
      {/* Linked nodes */}
      {points.map((p, i) => (
        <g key={`n-${i}`} data-testid={`graph-node-${i}`}
           style={{ cursor: "pointer" }}
           onClick={() => onNodeClick && onNodeClick(p)}>
          <circle cx={p.x} cy={p.y} r={22}
                  fill={p.flagged ? "rgba(239,68,68,0.18)" : "rgba(37,99,235,0.15)"}
                  stroke={colorFor(p.flagged)} strokeWidth={2} />
          <text x={p.x} y={p.y + 4} textAnchor="middle"
                fill="#f1f5f9" fontSize="10" fontWeight="700">
            {(p.label || "").slice(0, 2).toUpperCase()}
          </text>
          <text x={p.x} y={p.y + 38} textAnchor="middle"
                fill={p.flagged ? "#fca5a5" : "#94a3b8"} fontSize="10">
            {(p.label || "").length > 22 ? (p.label.slice(0, 20) + "…") : p.label}
          </text>
          {p.flagged && (
            <text x={p.x} y={p.y + 50} textAnchor="middle"
                  fill="#ef4444" fontSize="8" fontWeight="700"
                  style={{ letterSpacing: 1 }}>FLAGGED</text>
          )}
        </g>
      ))}
      {/* Centre node */}
      <circle cx={cx} cy={cy} r={42}
              fill={center.flagged ? "rgba(239,68,68,0.25)" : "rgba(37,99,235,0.25)"}
              stroke={colorFor(center.flagged)} strokeWidth={3} />
      <text x={cx} y={cy + 4} textAnchor="middle"
            fill="#f1f5f9" fontSize="13" fontWeight="800">
        {(center.label || "?").slice(0, 14)}
      </text>
      {nodes.length === 0 && (
        <text x={cx} y={H - 30} textAnchor="middle" fill="#64748b" fontSize="11">
          No linked entities found in your data.
        </text>
      )}
    </svg>
  );
}
